/** @import modules */

import { 
    
    useNavigate, 
    
    useParams }                 from "react-router-dom";

import { useTranslation }       from "react-i18next";

/** @import datasets */

import { BatteriesPagination }  from "../../../../Datasets/Products";

/** @import hooks */

import { BatteriesNavigator }   from "../../../../Hooks/BatteriesNavigator";

/**
 * 
 * @param { attributes } param0 
 * 
 * @returns Product pagination component
 * 
 */

const Pagination = ( { pageInfo, totalCount } ) => { const

    { t }                   = useTranslation (),
    
    navigate                = useNavigate   (),
    
    { parameters }          = useParams     (),

    pageSize                = 21,

    lastPageSize            = totalCount % pageSize || pageSize,

    totalPages              = Math.ceil ( totalCount / pageSize ),

    currentPage             = Math.max ( 1, parseInt ( new URLSearchParams ( parameters ).get ( "p" ) ) || 1 ),

    buttons                 = BatteriesPagination ( pageInfo ).map ( ( button, index ) => {

        if ( index === 0 ) return { ...button, query: { ...button.query, p: 1 } };

        if ( index === 1 ) return { ...button, query: { ...button.query, p: Math.max ( 1, currentPage - 1 ) } };

        if ( index === 2 ) return { ...button, query: { ...button.query, p: currentPage + 1 } };

        if ( index === 3 ) return { ...button, query: { ...button.query, l: lastPageSize, p: totalPages } };

        return button;

    } ),

    navigateTo              = query => navigate (

        `/shop/batteries/${ new URLSearchParams ( BatteriesNavigator ( parameters, query ) ).toString () }`

    );

    /** @returns component */

    return ( <div className="pagination">

        { currentPage > 1 && <button className="navigation-button"

        onClick={ () => navigateTo ( buttons[ 1 ].query ) } disabled={ buttons[ 1 ].state }>

            { buttons[ 1 ].icon }

        </button> }

        { currentPage === 1 ? <button className="current-page" aria-current="page" disabled>1</button> : <button

        className="page-number" onClick={ () => navigateTo ( buttons[ 0 ].query ) }>

            1

        </button> }

        { currentPage > 3 && <span className="pagination-ellipsis">...</span> }

        { buttons[ 1 ]?.disableState && ! buttons[ 1 ].state && currentPage > 2 && <button className="page-number" onClick={ () => navigateTo ( buttons[ 1 ].query ) }>

            { currentPage - 1 }

        </button> }

        { currentPage > 1 && <button className="current-page" aria-current="page" disabled>{ currentPage }</button> }

        { buttons[ 2 ]?.disableState && ! buttons[ 2 ].state && currentPage < totalPages && <button className="page-number" onClick={ () => navigateTo ( buttons[ 2 ].query ) }>

            { currentPage + 1 }

        </button> }

        { currentPage < totalPages - 2 && <span className="pagination-ellipsis">...</span> }

        { totalPages > currentPage + 1 && <button className="page-number" onClick={ () => navigateTo ( buttons[ 3 ].query ) }>

            { totalPages }

        </button> }

        { currentPage < totalPages && <button className="navigation-button"

        onClick={ () => navigateTo ( buttons[ 2 ].query ) } disabled={ buttons[ 2 ].state }>

            { buttons[ 2 ].icon }

        </button> }

    </div> );

}

/** @export component */
 
export default Pagination;